export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            了解97影视的初心与使命
          </p>
        </div>

        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="prose prose-sm md:prose-base max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              97影视创立于对电影和电视剧的无限热爱。我们深知，在这个快节奏的时代，
              能够静下心来欣赏一部好作品是一种奢侈的享受。因此，我们致力于打造一个
              <strong>高清免费在线观看平台</strong>，让每一位用户都能享受到
              <strong>极速秒播、无广告干扰</strong>的纯净观影体验。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们收录了海量高清电影和电视剧资源，涵盖动作、喜剧、科幻、悬疑、爱情、恐怖、纪录片等多个类型。
              平台每日同步更新热播内容，采用先进的播放技术和CDN加速网络，
              确保在任何设备上都能流畅观看。无论你偏好最新院线大片，还是怀念经典老片，
              97影视都希望成为你追剧观影的首选平台。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              97影视始终坚持<strong>免费、高清、无广告</strong>的核心理念。
              我们相信好的内容值得被更多人看到，好的观影体验不应该被广告打断。
              未来，我们将持续优化平台功能，丰富资源内容，为每一位热爱影视的你提供更好的服务。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
            {[
              { value: '10万+', label: '影视资源' },
              { value: '99.9%', label: '在线率' },
              { value: '500万+', label: '月活用户' },
              { value: '5年', label: '稳定运营' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}